export const GetPropsMenu = (path) => {
  var defaultSelectedKeys = "1";
  switch (path) {
    case "/app/admin/managerial":
    case "/app/customer/managerial":
      defaultSelectedKeys = "managerial";
      break;
    case "/app/admin/users":
      defaultSelectedKeys = "users";
      break;
    default:
      break;
  }
  return { defaultSelectedKeys };
};
